module.exports = __webpack_public_path__ + "img/P150T_weapon_16.fd0a3d50.png";